// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 143 ? "app" : chunkId) + "." + {"73":"aac63c55db7616116336","143":"1bb88cb5df062f79b90b"}[chunkId] + ".css";
};